import React, { useState, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { createlistacancion, postLoginUsuarioPruebas } from "../../Servicios/Servicios";

const YOUTUBE_API_KEY = "AIzaSyC4UwcnlEu-urUoO_1Gpf3fhpOGNPcqvKg"; // Reemplaza con tu API Key

export default function BuscarCancion({ evento, idAsistencia }) {
  const { query } = useParams();
  const [valueFind, setValueFind] = useState("");
  const [cargandoBusqueda, setCargandoBusqueda] = useState(true);
  const [itemResponseYoutube, setItemResponseYoutube] = useState([]);
  const [cancionesGuardadas, setCancionesGuardadas] = useState(0);
  const [bloqueado, setBloqueado] = useState(false);
  const [guardandoId, setGuardandoId] = useState(null); // ✅ Para controlar qué canción se está enviando
  const cancelTokenRef = useRef(null);
  let debounceTimeout = null;

  const findSongOrArtist = async () => {
    if (!valueFind.trim() || !cargandoBusqueda) return;

    setCargandoBusqueda(false);

    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel("Nueva búsqueda iniciada");
      cancelTokenRef.current = null;
    }

    cancelTokenRef.current = axios.CancelToken.source();

    if (debounceTimeout) clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(async () => {
      try {
        const searchUrl = `https://www.googleapis.com/youtube/v3/search?part=snippet&type=video&maxResults=10&q=${encodeURIComponent(
          valueFind
        )}&key=${YOUTUBE_API_KEY}`;

        const { data } = await axios.get(searchUrl, {
          cancelToken: cancelTokenRef.current.token,
        });

        if (!data.items || data.items.length === 0) {
          setItemResponseYoutube([]);
          return;
        }

        const videoIds = data.items.map((item) => item.id.videoId).join(",");
        const statusUrl = `https://www.googleapis.com/youtube/v3/videos?part=status&id=${videoIds}&key=${YOUTUBE_API_KEY}`;
        const { data: statusData } = await axios.get(statusUrl);

        const embeddableVideos = data.items.filter((item) => {
          const videoStatus = statusData.items.find(
            (v) => v.id === item.id.videoId
          );
          return videoStatus?.status?.embeddable;
        });

        setItemResponseYoutube(embeddableVideos);
      } catch (error) {
        if (axios.isCancel(error)) return;
        console.error("❌ Error en búsqueda YouTube:", error);
        setItemResponseYoutube([]);
      } finally {
        setCargandoBusqueda(true);
        cancelTokenRef.current = null;
      }
    }, 400);
  };

  const guardarcancion = async (item) => {
    if (bloqueado) {
      alert("Debes esperar 1 minuto para volver a guardar una canción.");
      return;
    }
    if (cancionesGuardadas >= 3) {
      setBloqueado(true);
      alert("Has alcanzado el límite de 3 canciones. Espera 1 minuto para volver a guardar.");
      setTimeout(() => {
        setCancionesGuardadas(0);
        setBloqueado(false);
      }, 60000);
      return;
    }

    setGuardandoId(item.id.videoId); // ✅ Activa spinner solo en este botón

    try {
      const responseData = await postLoginUsuarioPruebas();
      const token = responseData.access;
      const fechaFormate = new Date().toISOString().split("T")[0];

      const cancion = {
        idEvento: query,
        idAsistencia: idAsistencia || 0,
        nombreCancion: item.snippet.title,
        artista: item.snippet.channelTitle,
        albun: "YouTube Video",
        duracion: "Desconocida",
        linkFotoCancion: item.snippet.thumbnails?.medium?.url,
        fechaSolicitada: fechaFormate,
        estadoCancion: "sin iniciar",
        linkReproductor: `https://www.youtube.com/watch?v=${item.id.videoId}`,
      };

      const response = await createlistacancion(cancion, token);

      if (response.data?.id || response.data?.resultados) {
        alert("✅ Canción agregada exitosamente a la lista.");
        setCancionesGuardadas((prev) => prev + 1);
      } else {
        alert("Error al agregar la canción. Inténtalo de nuevo.");
      }
    } catch (error) {
      console.error("❌ Error al agregar la canción:", error);
      alert("Error al agregar la canción. Inténtalo de nuevo.");
    } finally {
      setGuardandoId(null); // ✅ Quita el spinner
    }
  };

  return (
    <div className="max-w-xl w-full mx-auto p-4 rounded-lg shadow mt-4" id="CuadrosEstandarColor">
      <h2 className="text-lg font-bold mb-4 text-white">Buscar Canción o Artista</h2>

      <div className="flex flex-col sm:flex-row gap-2 mb-4">
        <input
          type="text"
          className="border rounded px-3 py-2 w-full"
          placeholder="Escribe el nombre de la canción o artista..."
          value={valueFind}
          onChange={(e) => setValueFind(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && findSongOrArtist()}
        />
        <button
          className="bg-[#4F60A8] cursor-pointer text-white px-4 py-2 rounded w-full sm:w-auto"
          onClick={findSongOrArtist}
          disabled={!valueFind.trim() || !cargandoBusqueda}
        >
          Buscar
        </button>
      </div>

      {!cargandoBusqueda && (
        <div className="text-center text-gray-500 mb-2">Buscando...</div>
      )}

      <div className="flex flex-col gap-2">
        {itemResponseYoutube.length === 0 && cargandoBusqueda && (
          <div className="text-gray-400 text-sm">No se encontraron resultados.</div>
        )}
        <div className="h-96 overflow-y-auto">
          {itemResponseYoutube.map((item) => (
            <div
              key={item.id.videoId}
              className="flex flex-wrap items-center rounded-md p-2 mt-2 w-full" id="CuadrosEstandarColor"
            >
              <img
                src={item.snippet.thumbnails.default.url}
                alt={item.snippet.title}
                className="w-12 h-12 rounded mr-3 flex-shrink-0"
              />
              <div className="flex flex-col flex-1 min-w-0">
                <span className="font-medium text-white truncate w-full">
                  {item.snippet.title}
                </span>
                <span className="text-xs text-gray-300 truncate w-full">
                  {item.snippet.channelTitle}
                </span>
              </div>

              {/* ✅ Botón con spinner */}
              <button
                className={`${
                  guardandoId === item.id.videoId
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                } text-white px-3 py-1 rounded ml-2 text-xs w-full sm:w-auto mt-2 sm:mt-0 flex items-center justify-center`}
                onClick={() => guardarcancion(item)}
                disabled={bloqueado || guardandoId === item.id.videoId}
              >
                {guardandoId === item.id.videoId ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"></div>
                    Guardando...
                  </>
                ) : (
                  "Enviar canción"
                )}
              </button>
            </div>
          ))}
        </div>
        {bloqueado && (
          <div className="text-red-500 text-xs mt-2">
            Has alcanzado el límite de 3 canciones. Espera 1 minuto para volver a guardar.
          </div>
        )}
      </div>
    </div>
  );
}
